/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum mccs_charge_payment_type {
  PENALTY = 'penalty',
  NEW_APPLICATION = 'new_application',
  BROKER_REGISTRATION = 'broker_registration',
  NEW_VEHICLE = 'new_vehicle',
  RENEWAL = 'renewal',
  RE_REGISTERED_VEHICLE = 're_registered_vehicle',
  VEHICLE_ADDITION = 'vehicle_addition',
  INSURANCE = 'insurance',
}
